import { num, qtd } from '../../format';
import { formatCurrency } from '../../../../../utils/FormatFunctions';

/* Leitura dos alertas/cruzamentos do motor de auditoria — compartilhado entre
 * o Dashboard da empresa e a tela de Auditorias (mesma fonte: audit_cte). */

/** Regra do motor → tela onde o contador RESOLVE o furo (chave = prefixo da regra).
 *  Cobre os 14 códigos que o motor (audit_cte) emite hoje; fallback p/ o painel geral. */
export const ALERTA_REGRA_TO_SCREEN: Record<string, string> = {
  SN: 'simples', // SN-01 Fat×BaseSN, SN-02 DAS×Tributos
  MS: 'impApurados', // MS-01 Faturou sem apurar imposto
  IC: 'impApurados', // IC-01 ICMS Déb-Créd × Recolher
  FC: 'contabil', // FC-01 Fat Fiscal × Receita Contábil
  IFC: 'integracao', // IFC-01/02 nota sem integração / valor fiscal≠contábil
  FL: 'pessoal', // FL-01/02/03 Folha, FGTS, INSS
  ES: 'obrigacoes', // ES-01 eSocial
  DC: 'obrigacoes', // DC-01 DCTFWeb
  FE: 'fechamento', // FE-01 fechamento atrasado
  NM: 'manuais', // NM-01 notas manuais em excesso
};
export const screenForRegra = (regra: string): string =>
  ALERTA_REGRA_TO_SCREEN[regra.split('-')[0]] ?? 'auditorias';

/** Natureza do valor — sem isto o rótulo "R$" mente (FE=dias, NM/IFC-01=qtd). */
export type NaturezaRegra = 'valor' | 'presenca' | 'contagem' | 'dias';
const NATUREZA: Record<string, NaturezaRegra> = {
  SN: 'valor',
  IC: 'valor',
  FC: 'valor',
  FL: 'valor',
  IFC: 'valor',
  MS: 'presenca',
  ES: 'presenca',
  DC: 'presenca',
  NM: 'contagem',
  FE: 'dias',
};
export const naturezaDe = (regra: string): NaturezaRegra =>
  regra === 'IFC-01' ? 'contagem' : (NATUREZA[regra.split('-')[0]] ?? 'valor');

/** Divide o `descricao` "A vs B" nos dois lados; labelB nulo quando não há " vs ". */
export const splitLados = (descricao: string): { labelA: string; labelB: string | null } => {
  const p = descricao.split(/\s+vs\.?\s+/i);
  return p.length === 2
    ? { labelA: p[0].trim(), labelB: p[1].trim() }
    : { labelA: descricao.trim(), labelB: null };
};

/** Formata UM lado (valor_a/valor_b) na unidade da regra. */
export const fmtLado = (regra: string, v: unknown): string => {
  const nat = naturezaDe(regra);
  if (nat === 'dias') return `${qtd(v)} dias`;
  if (nat === 'contagem') return `${qtd(v)} notas`;
  return formatCurrency(num(v));
};

/** Valor da "Diferença" na unidade certa (IFC-01: lados são qtd, mas Δ é R$). */
export const valorDiferenca = (regra: string, diferenca: unknown): string => {
  if (regra === 'IFC-01') return formatCurrency(num(diferenca));
  return fmtLado(regra, diferenca);
};

const MESES_PT = [
  'jan',
  'fev',
  'mar',
  'abr',
  'mai',
  'jun',
  'jul',
  'ago',
  'set',
  'out',
  'nov',
  'dez',
];
/** "2026-03-01" → "mar/2026". */
export const competenciaLabel = (periodo: string): string => {
  if (!periodo || periodo.length < 7) return periodo || '—';
  const ano = periodo.slice(0, 4);
  const mes = Number(periodo.slice(5, 7));
  return mes >= 1 && mes <= 12 ? `${MESES_PT[mes - 1]}/${ano}` : periodo;
};
